import script from "./statementqrcode.vue?vue&type=script&setup=true&name=Qrcode&lang=js"
export * from "./statementqrcode.vue?vue&type=script&setup=true&name=Qrcode&lang=js"

import "./statementqrcode.vue?vue&type=style&index=0&id=040465d0&lang=css"

const __exports__ = script;

export default __exports__